<template>
  <div style="height:100%">
    <TableMain name="one table" ref="QuotationOrderTable1" :fields="fields" :title="table_title.title1"
      :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
      :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query"
      :show_toolbar_button="[0, 0, 1, 1, 0, 0, 0, 1]" :hb_table_class="'hb_table_quotationorder_class1'"
      @tool_invoke="tool_invoke" @state_change="state_change" tableref="b418b85a4a6e44f4b567ca9c9080e6c3">
      <template #query>
        <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
          align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions()">
        </el-date-picker>
        <el-select label="销售公司" size="small" v-model="dataAreaId" filterable clearable placeholder="请选择销售公司"
          class="w-5 ml-1">
          <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
            :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
        </el-select>
        <el-select label="报价申请单号" size="small" v-model="QuotationTaskNum" filterable remote reserve-keyword
          :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')" @focus="QTRemoteMethod('')"
          placeholder="请输入报价申请编号关键词" class="w-5 ml-1">
          <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
        </el-select>
      </template>
      <template #toolbar>
        <el-button type="danger" plain @click="resendEmailToApprover" class="ml-2 iconfont icon-email"
          size="mini">发送邮件</el-button>
        <div style="display: inline-block">
          <el-checkbox-group style="display: inline-block" class="ml-2" v-model="checkedConditions"
            @change="only_methods">
            <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{ item.label
              }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </TableMain>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as QuotationOrderController from "../../controllers/sd/QuotationOrderController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as localStorageMgr from "../../shared/localStorageMgr"
import SplitContainer2 from "../components/container/SplitContainer2"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer2,
    TableMain
  },
  data() {
    return {
      date_picker_label: "",
      date_range: [this.$date.addMonths(new Date(), -6), new Date()],
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "quote_apply",
        title2: "quote_apply_detail",
      },
      fields: _.cloneDeep(QuotationOrderController.fields.default),
      // fields1: _.cloneDeep(QuotationOrderController.fields.detail),
      ItemId: "",
      isBusy: false,
      dataAreaId: "",
      CustName: "",
      QuotationTaskNum: "",
      QTOptions: [],
      all_role_users: [],
      onlyMyApproved: true,
      only_un_approved: false,
      SalesQuoteOrderHis: [],
      local_username: "",
      checkedConditions: [2],
      onlyCheckOptions: [
        { value: 2, label: "仅待我审批" },
        { value: 1, label: "仅待审批" },
        { value: 3, label: "仅已审批" }
      ],
    }
  },
  async created() {
    await this.getAllRoleUsers()
  },
  watch: {
    "$route": {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.QuotationTaskNum = val.query.k
            this.on_query(this.$refs.QuotationOrderTable1.SetData)
          }
        }
      },
      deep: true
      // immediate: true
    },
  },
  async mounted() {
    this.local_username = localStorageMgr.get(localStorageMgr.data.last_login_account)
    await this.on_query(this.$refs.QuotationOrderTable1.SetData)
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum }
        })
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query)
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    myApproveChange(list) {
      let _roles = []
      let _username = this.$global.global_data.local_username
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _list = []
      _.each(list, (t) => {
        if (
          !_.isNull(t.fcGetSQOrderApprover) &&
          t.fcGetSQOrderApprover
        ) {
          let name_or_role = t.fcGetSQOrderApprover.split(",")[0]
          let _is_role = t.fcGetSQOrderApprover.split(",")[1]
          if (_is_role == 1) {
            if (_.includes(_roles, name_or_role)) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          } else {
            if (_username == name_or_role) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          }
        }
      })
      return _list
    },
    only_methods(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.SalesQuoteOrderHis)
      if (checkedValue == 1) {///未审批
        dt = _.filter(dt, { fcCheckSQOrderApproved: false, isOrderRefused: 0 })
      }
      else if (checkedValue == 2) {///仅待我审批
        dt = _.filter(dt, (t) => { return t.SQOrderApprover && t.SQOrderApprover.indexOf(this.local_username) > -1 })
      }
      else if (checkedValue == 3) { ///已审批
        dt = _.filter(dt, { fcCheckSQOrderApproved: true, isOrderRefused: 0 })
      }
      this.$refs.QuotationOrderTable1.SetData(dt)
    },
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let hasDate = true
      let p = {}
      if (this.dataAreaId != "") {
        p.dataAreaId = this.dataAreaId
        hasDate = false
      }
      if (this.CustName != "") {
        p.CustName = _.trim(this.CustName)
        hasDate = false
      }
      if (this.QuotationTaskNum && this.QuotationTaskNum != "") {
        p.QuotationTaskNum = _.trim(this.QuotationTaskNum)
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p.date_from = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        p.date_to = _toDate
      }
      let _result = await QuotationOrderController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let filterAllConfirmDt = _.filter(_result[0], { isWeightedCostAllConfirm: true })
        _.each(filterAllConfirmDt, (m) => {
          this.getApprover(m)
        })
        let dt = _.orderBy(filterAllConfirmDt, ["QuotationTaskId", "QuotationTaskLineNum"], ["desc", "asc"])
        this.SalesQuoteOrderHis = _.cloneDeep(dt)
        this.only_methods(this.checkedConditions)
      }
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSQOrderApprover",
        "SQOrderApprover",
        t.fcCheckSQOrderApproved
      )
    },
    current_changed(old, current) {
      this.$refs.QuotationOrderTable2.SetData([])
      if (current) {
        let dt = _.filter(this.SalesQuoteOrderHis, { QuotationTaskNum: current.QuotationTaskNum })
        this.$refs.QuotationOrderTable2.SetData(_.orderBy(dt, ["QuotationTaskLineNum"], ["asc"]))
      }

    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }

      let p = {}, approve_dt = []
      if (data.state == "approved" || data.state == "unapproved") {
        let refused_exists = _.some(data.selected_items, { isOrderRefused: 1 })
        if (data.state == "approved" && refused_exists) {
          this.msgToasts("已退回数据不能执行该操作！", "info")
          cb(false)
          return
        }
        let approved_exists = _.some(data.selected_items, { fcCheckSQOrderApproved: true })
        if (data.state == "approved" && approved_exists) {
          this.msgToasts("已审批数据不能执行该操作！", "info")
          cb(false)
          return
        }
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckSQOrderApproved == !(data.state == "approved") })
        approve_dt = _.cloneDeep(dt)
        let check_ap_res = []
        ///检查是否有该权限
        let _check_ap_params = {
          list: _.map(_.cloneDeep(dt), (t) => { t.id = t.quotationtask_detail_id; return t }),
          DocumentType: "SalesQuoteOrder",
          approve_type: "",
          isNotCheckPrivilage: data.state == "approved" ? false : true,
          action_state: data.state == "approved",
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0) {
          this.msgToasts(`抱歉，暂无审批编号（${_.join(check_ap_res.notPriviligeIdList, "，")}）的权限！`, "error")
          cb(false)
          return
        }
        p.approved = {}
        p.approved.data = []
        p.approved.local_username = this.$global.global_data.local_username
        let _approveStatusIdList = _.filter(check_ap_res.approveStatusIdList, { isApproved: data.state == "approved" ? false : true })

        p.approved.approveStatusIdList = _.orderBy(_approveStatusIdList, ["ApproveLevel"], ["asc"])
        let confirm_m = await this.$prompt('请输入审批意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入审批意见',
          inputValue: "同意"
        }).then(({ value }) => {
          cb(false)
          return { state: true, val: value }
        }).catch(() => {
          cb(false)
          return { state: false }
        })
        if (confirm_m && confirm_m.state) {
          cb(false)
          p.approved.ApproveRemark = confirm_m.val
        }
        else {
          cb(false)
          return
        }
      }
      if (data.state == "refused") {
        let dt = _.filter(data.selected_items, (t) => { return t.fcCheckSQOrderApproved == false })
        approve_dt = _.cloneDeep(dt)
        if (dt && dt.length == 0) {
          this.msgToasts("已审批数据不能执行该操作！", "info")
          cb(false)
          return
        }
        let confirm_m = await this.$prompt('请输入退回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入原因'
        }).then(({ value }) => {
          return { state: true, val: value }
        }).catch(() => {
          return { state: false }
        })

        if (confirm_m && confirm_m.state) {
          p.approved = {}
          p.approved.data = []
          _.each(data.selected_items, (t) => {
            p.approved.data.push({
              id: t.quotationtask_detail_id,
              SQOrderDescription: confirm_m.val
            })
          })
        }
        else {
          cb(false)
          return
        }
      }
      let loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let rt = await QuotationTaskController.methods.saveData(p)
      if (rt) {
        await this.on_query(this.$refs.QuotationOrderTable1.SetData, false)
        await setTimeout(async () => {
          ///审批后发邮件
          if (data.state === "approved" || data.state === "refused") {
            let email_user = [], email_next_dt = [], email_last_dt = []
            _.each(approve_dt, (t) => {
              let m = _.find(this.SalesQuoteOrderHis, { quotationtask_detail_id: t.quotationtask_detail_id })
              if (m && m.fcGetSQOrderApprover && data.state === "approved") {
                email_user.push(m.fcGetSQOrderApprover.split(",")[0])
                email_next_dt.push(m)
              }
              email_user = _.uniqWith(email_user, _.isEqual)
              ///整理审批完成或者拒批发邮件的数据
              let last_m = _.find(this.SalesQuoteOrderHis, (mt) => {
                return mt.quotationtask_detail_id == t.quotationtask_detail_id && (mt.fcCheckSQOrderApproved || mt.isOrderRefused == 1)
              })
              if (last_m) email_last_dt.push(last_m)
            })
            //发送邮件给下一审批人
            if (email_next_dt.length > 0) {
              let p = _.map(email_next_dt, (t) => { return { DetailId: t.quotationtask_detail_id, IsHomemade: '' } })
              await commonController.handleEmailNotify(p, "quote_order_confirm", this, null, "email_get_quote_data", email_user)
            }
            //审批完成发送给报价申请创建人
            if (email_last_dt.length > 0)
              await this.SendEmail(email_last_dt, data.state)
          }
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          cb(true)
          loading.close()
        }, 1500)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        loading.close()
        cb(false)
      }
    },
    ///重新发邮件给当前审批人
    async resendEmailToApprover() {
      let approve_dt = this.$refs.QuotationOrderTable1.GetSelectedItems()
      if (approve_dt.length == 0) return
      let email_user = [], email_next_dt = [], email_last_dt = []
      _.each(approve_dt, (t) => {
        let m = _.find(this.SalesQuoteOrderHis, { quotationtask_detail_id: t.quotationtask_detail_id })
        if (m && m.fcGetSQOrderApprover) {
          email_user.push(m.fcGetSQOrderApprover.split(",")[0])
          email_next_dt.push(m)
        }
        email_user = _.uniqWith(email_user, _.isEqual)
        ///整理审批完成或者拒批发邮件的数据
        let last_m = _.find(this.SalesQuoteOrderHis, (mt) => {
          return mt.quotationtask_detail_id == t.quotationtask_detail_id && (mt.fcCheckSQOrderApproved || mt.isOrderRefused == 1)
        })
        if (last_m) email_last_dt.push(last_m)
      })
      //发送邮件给下一审批人
      if (email_next_dt.length > 0) {
        let p = _.map(email_next_dt, (t) => { return { DetailId: t.quotationtask_detail_id, IsHomemade: '' } })
        await commonController.handleEmailNotify(p, "quote_order_confirm", this, null, "email_get_quote_data", email_user)
      }
      //审批完成发送给报价申请创建人
      if (email_last_dt.length > 0)
        await this.SendEmail(email_last_dt, true)
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    ///发送报价申请处理邮件
    async SendEmail(data, action_type) {
      this.email_action_type = action_type
      let p = _.map(data, (t) => { return { QuotationTaskNum: t.QuotationTaskNum } })
      p = _.uniqWith(p, _.isEqual)
      await commonController.handleEmailNotify(p, "quote_order_approved", this, this.all_role_users, "get_quotation_order",)
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_quotationorder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 210rem;
}
</style>
